<template>
    <div>

        {{ sections }}
        <div class="grid grid-cols-[repeat(9,_minmax(0,_1fr))_35px] gap-3 font-bold py-2">
            <span class="col-span-6">Fee</span>
            <span class="col-span-2">%</span>
            <span class="">Predefinita</span>
            <NextButton variant="primary" @click="addFee"
                        class="col flex justify-center items-center h-8 w-8"><i class="icon-croce_quadrata"></i></NextButton>
        </div>
        <div class="grid grid-cols-[repeat(9,_minmax(0,_1fr))_35px] gap-3 mb-3 items-cente" v-for="(f,i) in fee_data" :key="i">
            <div class="col-span-6">
                <Field v-model="f.descrizione" :label-visible="false" placeholder="Descrizione"></Field>
            </div>
            <input type="number" min="0" step=".01" v-model="f.valore" placeholder="Valore"
                   class="col-span-2 p-2 bg-next-gray-md-dark hover:bg-white w-full">
            <div class="flex justify-center">
                <Radio :value="i" name="default" :modelValue="default_fee"  @update:modelValue="updateVal" checkClass="w-3 h-3"></Radio>
            </div>
            <NextButton variant="outline-secondary" @click="removeFee(i)"
                        class="col flex justify-center items-center  h-8 w-8"><i class="icon-x"></i></NextButton>
        </div>

        <div class="grid grid-cols-[repeat(9,_minmax(0,_1fr))_35px] gap-3 font-bold mb-3">
            <span class="col-span-6">Rebate</span>
            <span class="col-span-3">%</span>
            <NextButton variant="primary" @click="addRebate"
                        class="col flex justify-center items-center h-8 w-8"><i class="icon-croce_quadrata"></i></NextButton>
        </div>
        <div class="grid grid-cols-[repeat(9,_minmax(0,_1fr))_35px] gap-3 mb-3 items-center" v-for="(f,i) in rebate_data" :key="i">
            <div class="col-span-6">
                <Field v-model="f.descrizione" :label-visible="false" placeholder="Descrizione"></Field>
            </div>
            <input type="number" min="0" step=".01" v-model="f.valore" placeholder="Valore"
                   class="col-span-3 p-2 bg-next-gray-md-dark hover:bg-white w-full">
            <NextButton variant="outline-secondary" @click="removeRebate(i)"
                        class="col flex justify-center items-center h-8 w-8"><i class="icon-x"></i></NextButton>
        </div>


        <span class="block border-b"></span>
        <div class="py-2 flex">

            <div class="flex flex-col mr-3 grow">
                <Field v-model="default_markup_data" field_name="Mark-up di default" placeholder="Mark-up percentuale"
                       type="number"></Field>
            </div>

            <div class="flex flex-col mr-3 w-1/4">
                <Field field_name="Applica alla sezione" :required="false">
                    <VueMultiselect
                                    :options="sections"
                                    v-model="section_to_apply"
                                    track-by="id" label="titolo"
                                    placeholder="sezione"
                                    deselectLabel="Deseleziona"
                                    selectedLabel="Selezionato"
                                    selectLabel="Seleziona"
                                    class="next-vue-multiselect-single ">
                    </VueMultiselect>
                </Field>
            </div>

            <NextButton variant="primary"
                        @click="applicaATutti"
                        class="col-start-3 py-2 px-4 self-end">
                {{applicaLabel}}
            </NextButton>
        </div>

        <div class="flex justify-end pt-3">
            <NextButton variant="outline-secondary"
                        @click="chiudi"
                        class="col-start-3 py-2 px-4">
                Chiudi
            </NextButton>
            <NextButton variant="primary"
                        @click="save"
                        class="ml-4 py-2 px-4">
                Salva
            </NextButton>
        </div>
    </div>
</template>

<script lang="ts">
import {Options, Vue, setup} from 'vue-class-component';
import NextButton from "@/components/NextButton.vue";
import Field from "@/components/Field.vue";
import Radio from "@/components/Radio.vue";
import Select from "@/components/Select.vue";

@Options({
    name:'FeeRebateForm',
    components: {
        Select,
        Radio,
        Field,
        NextButton
    },
    props: {
        fee: Array,
        sections: Array,
        rebate: Array,
        default_markup: [String, Number],
    }
})
export default class FeeRebateForm extends Vue {

    fee!: any[]
    sections!: any[]
    rebate!: any[]
    default_fee = -1
    default_markup!:number

    fee_data: any[] = []
    rebate_data: any[] = []
    default_markup_data!:number|string
    section_to_apply:any = null

    updateVal($event:any){
        this.default_fee = (this.default_fee==$event ? null : $event)
    }

    get applicaLabel() {
        return this.section_to_apply ? 'Applica alla sezione' : 'Applica a tutte le sezioni'
    }

    init() {
        // li riparseo per evitare che quando chiudo il modal senza salvare mi vada a modificare l'oggetto originario
        let fee_data = JSON.parse(JSON.stringify(this.fee))
        if(!fee_data.length){
            fee_data = [{descrizione: undefined, valore: undefined}]
        }
        let rebate_data = JSON.parse(JSON.stringify(this.rebate))
        if(!rebate_data.length){
            rebate_data = [{descrizione: undefined, valore: undefined}]
        }
        const def = fee_data.findIndex((el:any)=>el.default)
        if(def > -1){
            this.default_fee = def
        }
        this.fee_data = fee_data
        this.rebate_data = rebate_data
        this.default_markup_data = this.default_markup
    }

    created(){
        this.init()
    }

    addFee() {
        this.fee_data.push({descrizione: undefined, valore: undefined})
    }

    removeFee(i: number) {
        this.fee_data.splice(i, 1)
        if(this.default_fee >= this.fee_data.length){
            this.default_fee -= 1
        }
    }

    removeRebate(i: number) {
        this.rebate_data.splice(i, 1)
    }

    addRebate() {
        this.rebate_data.push({descrizione: undefined, valore: undefined})
    }

    save() {
        this.$emit('update:fee', this.fee_data.map((el, i) => {
            return {...el, id: i, default: i===this.default_fee}
        }))
        this.$emit('update:rebate', this.rebate_data.map((el, i) => {
            return {...el, id: i}
        }))
        this.$emit('update:default_markup', this.default_markup_data)
        this.chiudi()
    }

    chiudi(){
        this.$emit('chiudi')
    }

    applicaATutti(){
        this.$emit('applica_mark_up_a_tutti', {mk: this.default_markup_data,  section:this.section_to_apply})
    }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
</style>
